

















































































import TabsFloor from "@/components/tabs/floor.vue";
import Vue from "vue";
import Component from "vue-class-component";
import Page from "@/components/layout/page.vue";
import { Floor } from "@/swagger/models";
import { Committable, WrapService } from "@/plugins/committable";
import CommitResetBar from "@/components/data/commit-reset-bar.vue";
import Card from "@/components/layout/card.vue";
import PageHeader from "@/components/navigation/page-header.vue";
import { subject } from "@casl/ability";
import { floorService } from "@/services/floor";

// See https://github.com/kaorun343/vue-property-decorator for all options

@Component({
    name: "floor",
    components: { TabsFloor, PageHeader, Card, CommitResetBar, Page },
})
export default class FloorView extends Vue {
    committable: Committable<Floor>;

    // nextId: number = null;
    // previousId: number = null;

    async created() {
        try {
            this.committable = new Committable<Floor>({
                onCommit: WrapService(floorService, {
                    ignoredFields: ["deletedAt"],
                    routeIdParam: "floorId",
                    router: this.$router,
                }),
            });

            if (this.$route.params.floorId === "new") {
                this.committable.set(
                    floorService.build({
                        officeId: parseInt(this.$route.params.officeId),
                    }),
                );
            } else {
                const res = await floorService.getNew(parseInt(this.$route.params.floorId));
                this.committable.set(res.data);
                // this.previousId = res.previousId;
                // this.nextId = res.nextId;
            }
        } catch (e) {
            console.warn(e);
            await this.$router.back();
        }
    }

    get canEdit() {
        if (this.committable.loading.value) return false;
        // @ts-ignore
        if (this.$route.params.floorId === "new" && this.$can("create", "Floor")) return true;
        // @ts-ignore
        else if (this.$can("update", subject("Floor", this.committable?.original?.value))) return true;
        return false;
    }

    async deleteFloor() {
        if (!this.committable.original.value.id) return;
        if (!confirm("Are you sure you want to delete this floor?")) return;
        await floorService.delete(this.committable.original.value.id);
        await this.$router.replace({ name: "floors" });
    }
}
